import script from "./AddNewPrayerRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewPrayerRequest.vue?vue&type=script&setup=true&lang=js"

import "./AddNewPrayerRequest.vue?vue&type=style&index=0&id=5dc81eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc81eca"]])

export default __exports__